import { defineVariants } from "@/runtime/style-engine/define-variants";

const colorVariants = {
  primary: `[--loader-color:var(--color-primary)]`,
  secondary: `[--loader-color:var(--color-secondary)]`,
  accent: `[--loader-color:var(--color-accent)]`,
  error: `[--loader-color:var(--color-error)]`,
  warning: `[--loader-color:var(--color-warning)]`,
  info: `[--loader-color:var(--color-info)]`,
  success: `[--loader-color:var(--color-success)]`,
  neutral: `[--loader-color:var(--color-neutral)]`,
  mono: `[--loader-color:var(--color-foreground)]`,
};

/** Spinning ring loader. */
export const loaderCircleClasses = defineVariants({
  base: `block shrink-0 rounded-full border-2 border-(--loader-color)/20 border-t-(--loader-color) animate-spin`,
  variants: {
    size: {
      xs: `w-3 h-3`,
      sm: `w-4 h-4`,
      md: `w-6 h-6`,
      lg: `w-8 h-8`,
      xl: `w-12 h-12`,
    },
    color: colorVariants,
  },
  defaults: {
    size: "md",
    color: "mono",
  },
});

/** Indeterminate bar loader track. */
export const loaderBarTrackClasses = defineVariants({
  base: `relative overflow-hidden rounded-full bg-(--loader-color)/20 w-full`,
  variants: {
    size: {
      xs: `h-px`,
      sm: `h-0.5`,
      md: `h-1`,
      lg: `h-1.5`,
      xl: `h-2`,
    },
    color: colorVariants,
  },
  defaults: {
    size: "md",
    color: "mono",
  },
});

/** Animated fill inside the bar track. Inherits --loader-color from parent. */
export const loaderBarFillClasses = defineVariants({
  base: `absolute inset-0 bg-(--loader-color)`,
  variants: {
    complete: {
      false: `w-2/5 animate-[loader-bar_1.5s_ease-in-out_infinite]`,
      true: `w-full origin-left animate-[loader-bar-complete_0.6s_ease-out_forwards]`,
    },
  },
  defaults: {
    complete: "false",
  },
});
